import InterviewNote from '@/components/InterviewNote';
import TransparentButton from '@/trio-ui/TransparentButton';
import { InterviewNoteType } from '@/types/api';
import * as Styles from './InterviewNotesManager.styles';

export type CustomNoteType = Partial<
  InterviewNoteType & {
    isEditing: boolean;
  }
>;

type InterviewNotesManagerProps = {
  notes: CustomNoteType[];
  canAddNewNote: boolean;
  isActionLoading: boolean;
  onAddNewNote: (event: any) => void;
  onCancelAddNewInterviewNote: (interviewNoteIndex: number) => void;
  onAddNewInterviewNote: (index: number, newNote: CustomNoteType) => Promise<boolean>;
  onDeleteInterviewNote: (interviewNoteId: string) => Promise<boolean>;
  interviewId: string;
  interviewRecordingUrl?: string;
  onInterviewUpdate?: () => void;
  allowManageRecording?: boolean;
};

export default function InterviewNotesManager({
  canAddNewNote,
  isActionLoading,
  notes,
  onAddNewInterviewNote,
  onAddNewNote,
  onDeleteInterviewNote,
  onCancelAddNewInterviewNote,
  interviewId,
  interviewRecordingUrl,
  onInterviewUpdate,
  allowManageRecording = false,
}: InterviewNotesManagerProps): JSX.Element {
  return (
    <div>
      <Styles.Title>Meeting Notes</Styles.Title>

      {allowManageRecording && (
        <Styles.RecordingUploader
          name={`recording-uploader-${interviewId}`}
          interviewId={interviewId}
          recordingUrl={interviewRecordingUrl}
          onInterviewUpdate={onInterviewUpdate}
        />
      )}

      {notes.map((note, index) => {
        return (
          <InterviewNote
            isActionLoading={isActionLoading}
            key={note.id}
            id={note.id}
            author={note.user}
            publishedAt={note.updatedAt}
            index={index}
            note={note.note}
            onCancel={onCancelAddNewInterviewNote}
            onSave={onAddNewInterviewNote}
            onDelete={onDeleteInterviewNote}
          />
        );
      })}

      {canAddNewNote && (
        <TransparentButton onClick={onAddNewNote} isBlueButton>
          + New Note
        </TransparentButton>
      )}
    </div>
  );
}
